import { useEffect } from 'react';
import { getAudioService } from '../../infrastructure';
import { resumeBackgroundMusic } from '../assets/preloadSounds';

/**
 * Unlock Web Audio / Howler after the first user gesture (autoplay policy).
 * Mount once near the app root.
 */
export function useAudioUnlock(): void {
  useEffect(() => {
    const unlock = () => {
      getAudioService().unlock();
      // Browsers block autoplay until a gesture — start/resume BGM now.
      resumeBackgroundMusic();
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('keydown', unlock);
    };

    window.addEventListener('pointerdown', unlock, { once: true });
    window.addEventListener('keydown', unlock, { once: true });

    return () => {
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('keydown', unlock);
    };
  }, []);
}
